<template>
  <row>
    <eight-wide-column>
      <form
        id="action-form"
        class="ui form"
        style="min-width: 24.5rem">
        <input-group
          :value="action"
          :data="ActionForm"
          v-model="action"/>
      </form>
    </eight-wide-column>

    <action-preview :item="action"/>

    <!--<json-Output :json="action"/>-->
  </row>
</template>

<script>
import { ActionForm } from '../../forms/forms'
import { Action } from '../../structs/structs'

import InputGroup from '../InputGroup'
import ActionPreview from './ActionPreview'
import JsonOutput from '../JsonOutput'
import Row from '../utility/Row'
import EightWideColumn from '../utility/EightWideColumn'

export default {
  name: 'ActionForm',
  components: { EightWideColumn, Row, JsonOutput, ActionPreview, InputGroup },
  props: {
    existingItem: {
      type: Object,
      required: false,
      default () { return null }
    }
  },
  data () {
    return {
      ActionForm,
      action: new Action(this.existingItem || {})
    }
  },
  watch: {
    action: {
      handler (newValue) {
        this.$emit('validated-item', this.formIsValid() ? newValue : null)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.initializeFormValidator()
  },
  methods: {
    initializeFormValidator () {
      // Custom Form Validation Rule
      $.fn.form.settings.rules.endDayAfterStartDay = () => {
        return (parseInt(this.action.data.options.endDay) >= parseInt(this.action.data.options.startDay))
      }

      $('#action-form').form(
        {
          fields: {
            'title': {
              // Cannot be empty
              identifier: 'title',
              rules: [
                { type: 'empty', prompt: 'Action Title cannot be empty' }
              ]
            },
            'reminder-title': {
              // Cannot be empty
              identifier: 'reminder-title',
              rules: [
                { type: 'empty', prompt: 'Reminder Title cannot be empty' },
                { type: 'maxLength[255]', prompt: 'Please enter at most 255 characters' }
              ]
            },
            'reminder-body': {
              // Cannot be empty
              identifier: 'reminder-body',
              rules: [
                { type: 'empty', prompt: 'Reminder Description cannot be empty' },
                { type: 'maxLength[255]', prompt: 'Please enter at most 255 characters' }
              ]
            },
            'short-name': {
              // Cannot be empty
              identifier: 'short-name',
              rules: [
                { type: 'empty', prompt: 'Short Name cannot be empty' }
              ]
            },
            'start-day': {
              // Must not be negative and less than `end-day`
              identifier: 'start-day',
              rules: [
                // For the relevant rule to show, do not change the order of the `rules` array
                { type: 'not[-0]', prompt: 'Enter a valid, positive whole number' },
                { type: 'doesntContain[-]', prompt: 'Start Day cannot be negative' },
                { type: 'not[0]', prompt: 'Start Day cannot be 0' },
                { type: 'integer', prompt: 'Start Day must be whole number' },
                { type: 'integer[1..300]', prompt: 'Start Day must be a whole number between 1 to 300' }
              ]
            },
            'end-day': {
              identifier: 'end-day',
              rules: [
                // For the relevant rule to show, do not change the order of the `rules` array
                { type: 'not[-0]', prompt: 'Enter a valid, positive whole number' },
                { type: 'doesntContain[-]', prompt: 'End Day cannot be negative' },
                { type: 'not[0]', prompt: 'End Day cannot be 0' },
                { type: 'integer', prompt: 'End Day must be a positive whole number' },
                { type: 'integer[1..300]', prompt: 'End Day must be a whole number between 1 to 300' },
                { type: 'endDayAfterStartDay', prompt: 'End Day must be after Start Day' }
              ]
            }
          },
          inline: true
        }
      )
    },
    validateForm () {
      return $('#action-form').form('validate form')
    },
    formIsValid () {
      return $('#action-form').form('is valid')
    }
  }
}
</script>

<style scoped>

</style>
